import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Fade,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import styles from "./GlassyNavbar.module.css";
import { useNavigate } from "react-router-dom";
import FitbitIcon from '@mui/icons-material/Fitbit';

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Planner", path: "/planner"},
  {
    label: "Services",
    dropdown: ["Solar Panels", "Installation", "Maintenance"],
  },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

const GlassyNavbar = () => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();

  const handleOpen = (event, label) => {
    setAnchorEl(event.currentTarget);
    setOpenDropdown(label);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenDropdown(null);
  };

  const handleNavigateClick = (itemlabel, itemRoute) => {
    navigate(itemRoute);
  }

  return (
    <AppBar position="sticky" className={styles.glassNavbar} elevation={0}>
      <Toolbar className={styles.toolbar}>
        {/* Logo */}
        <Typography variant="h6" className={styles.logo}>
          <FitbitIcon /> {" Gupta Engineers and Solar Solutions"} 
        </Typography>

        {/* Nav Links */}
        <Box className={styles.navLinks}>
          {navLinks.map((link) =>
            link.dropdown ? (
              <Box
                key={link.label}
                onMouseEnter={(e) => handleOpen(e, link.label)}
                onMouseLeave={handleClose}
                className={styles.navItem}
              >
                <Button
                  endIcon={
                    <ExpandMore
                      sx={{
                        color: "black",
                        filter: "drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))",
                      }}
                    />
                  }
                  className={styles.linkBtn}
                >
                  {link.label}
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={openDropdown === link.label}
                  onClose={handleClose}
                  MenuListProps={{ onMouseLeave: handleClose }}
                  PaperProps={{
                    sx: {
                      background: "rgba(255, 255, 255, 0.15)",
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 255, 255, 0.25)",
                      color: "white",
                      boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
                      borderRadius: "12px",
                      overflow: "hidden",
                    },
                  }}
                >
                  {link.dropdown.map((item) => (
                    <MenuItem
                      key={item}
                      onClick={handleClose}
                      sx={{
                        color: "black",
                        textShadow: "0 0 4px rgba(255, 255, 255, 0.8)",
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
                      }}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            ) : (
              <Button key={link.label} className={styles.linkBtn} onClick={() => handleNavigateClick(link.label, link.path)}>
                {link.label}
              </Button>
            )
          )}
        </Box>

        {/* User Actions */}
        <Box className={styles.actions}>
          <Button variant="outlined" className={styles.signupBtn}>
            Sign Up
          </Button>
          <IconButton>
            <Avatar
              src="/user.jpg"
              alt="User"
              sx={{
                boxShadow: "0 0 6px rgba(0, 0, 0, 0.5)",
                border: "1px solid rgba(255, 255, 255, 0.7)",
              }}
            />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default GlassyNavbar;
